<template>
    <div>
        <input-form v-show="showForm" ref="userForm" :opt="operat"></input-form>
        <input-confirm v-show="!showForm" ref="userConfirm" :form="reqForm" :opt="operat"></input-confirm>
    </div>
</template>

<script>
    import InputForm from './Form'
    import InputConfirm from './Confirm'
    import SuccessMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import {getList} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            InputForm,
            InputConfirm,
        },
        data () {
            return {
                operat: 'show',
                showForm: false,
                reqForm: {}
            }
        },
        watch: {
            // サーバーエラーで画面制御
            getCompanyOperat (operat) {
                this.changeOperat(operat)
            },
            getCompanyDetail (info) {
                if (info.data.company_info) {
                    this.reqForm = info.data.company_info
                } else {
                    this.reqForm = {}
                }
            },
            getSaveCompanyInfoStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startSpinner')
                }
                if (status == '2') {
                    this.$store.dispatch('doneSpinner')
                    this.openMsg(0,"完了しました。")
                }
                if (status == '3') {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getSaveCompanyInfoStatus', 'getCompanyOperat' , 'getCompanyDetail'])
        },
        methods: {
            doSubmit () {
                this.reqForm['operat'] = this.operat

                if (this.operat == 'edit_confirm') {
                    this.$store.dispatch('saveCompanyInfo', this.reqForm)
                }
            },
            getChildData () {
                let userForm = this.$refs.userForm.getData()
                this.reqForm = Object.assign({}, this.reqForm, userForm)
            },
            openMsg (lev, msg, key="", id="") {
                this.$parent.openMsg(lev, msg, key, id)
            },
            changeOperat (opt) {
                if (opt == 'auto') {
                    this.operat = 'edit_confirm'
                } else {
                    this.operat = opt 
                }
                if (this.operat == 'edit') {
                    this.showForm = true
                }
                if (this.operat == 'edit_confirm' || this.operat == 'show') {
                    this.showForm = false
                }
                // スクロールをトップへ移動
                document.documentElement.scrollTop = 0
            },
            getList (name) {
                return getList(name)
            },
        }
    }
</script>

<style></style>
